import { kibanaLog } from './logger';

// Returns true when Context Hub account status is disconnected
export const selectIsDisconnected = status => status === 'D';

// Returns the service address from contextHub state normalized to the expected format
export const selectServiceAddress = (contextHubData = {}) => {
  const address = (contextHubData && contextHubData.address) || {};
  const {
    line1: addressLine1,
    line2: addressLine2,
    state,
    zip,
  } = address;
  const mergedAddressLine1 = [addressLine1, addressLine2]
    .filter(Boolean)
    .join(' ');
  return {
    addressLine1: mergedAddressLine1 || '',
    state: state || '',
    zip: zip || '',
  };
};

const ineligibleMobileStates = [
  'NOT_SUBSCRIBED',
  'PROSPECT',
  'CEASED',
  'INACTIVE',
];

// Returns true if the account has ever had active Xfinity services
export const hasEverHadXfinityServices = services => Object.values(services).some(
  (service) => {
    if (service.productClass === 'XFINITY' && service.status) {
      return true;
    }
    if (service.productClass === null && service.status) {
      kibanaLog('Let into Core with null productClass');
      return true;
    }
    return false;
  },
);

// Returns true if the account has ever had active NOW services
export const hasEverHadNowServices = services => Object.values(services).some(
  (service) => {
    if (service.productClass === 'NOW' && service.status) {
      return true;
    }
    if (service.productClass === null && service.status) {
      kibanaLog('Let into NOW with null productClass');
      return true;
    }
    return false;
  },
);

// Returns true if the mobile account is in an active (eligible) state
export const hasActiveMobileServices = account => !ineligibleMobileStates.includes(account?.state);
